var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsdt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 226.777,
    height: 226.777,
    viewBox: "0 0 226.777 226.777",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M226.883 107.66c0-14.245-38.761-26.13-90.27-28.872l-.004-22.697h64.315V8.855H25.06v47.236h64.31v22.808C38.799 81.829.97 93.59.97 107.66c0 14.072 37.829 25.834 88.4 28.759v81.504h47.239V136.53c51.513-2.736 90.274-14.625 90.274-28.87zm-112.957 14.033c-55.288 0-100.109-8.557-100.109-19.119 0-8.943 32.139-16.451 75.553-18.54v5.383h.005v22.059c7.827.439 16.053.669 24.551.669 7.825 0 15.424-.199 22.688-.563v-27.63c44.355 1.961 77.423 9.548 77.423 18.622-.001 10.562-44.823 19.119-100.111 19.119z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/USDT.d8f170d67df12f7ffcdbab2979ab9543.svg";
export { ForwardRef as ReactComponent };